import { render, staticRenderFns } from "./userModal.vue?vue&type=template&id=c12d75f6&scoped=true&"
import script from "./userModal.vue?vue&type=script&lang=js&"
export * from "./userModal.vue?vue&type=script&lang=js&"
import style0 from "./userModal.vue?vue&type=style&index=0&id=c12d75f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d75f6",
  null
  
)

export default component.exports